module.exports = __webpack_public_path__ + "img/testImage10.ccf33529.ccf33529.png";